import { RoleDefinitions } from '../types';
import { principalServiceRequest } from './base-request';

export const getLegacyRoleDefinitions = async (): Promise<RoleDefinitions> => {
  const result = await principalServiceRequest<RoleDefinitions>(
    'get',
    'legacy-role-definition',
  );

  return result.data;
};
